import React, { useEffect, useState } from "react";

// Persistent urgency countdown. Counts down a rolling window (default 3h)
// stored in localStorage so it feels real across reloads; resets when it hits 0.
export const CountdownTimer = ({ windowMs = 3 * 60 * 60 * 1000 }) => {
  const [remaining, setRemaining] = useState(windowMs);

  useEffect(() => {
    const key = "cric1x_offer_deadline";
    let deadline = parseInt(localStorage.getItem(key) || "0", 10);
    const now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + windowMs;
      localStorage.setItem(key, String(deadline));
    }
    const tick = () => {
      let diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + windowMs;
        localStorage.setItem(key, String(deadline));
        diff = windowMs;
      }
      setRemaining(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [windowMs]);

  const total = Math.max(0, Math.floor(remaining / 1000));
  const h = String(Math.floor(total / 3600)).padStart(2, "0");
  const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");

  const Box = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <span className="min-w-[46px] border border-gold/40 bg-black px-2 py-1.5 text-center font-mono text-2xl font-bold text-gold tabular-nums">
        {v}
      </span>
      <span className="mt-1 font-mono text-[9px] uppercase tracking-widest text-white/40">{l}</span>
    </div>
  );

  return (
    <div className="flex items-center gap-2" data-testid="countdown-timer">
      <Box v={h} l="Hrs" />
      <span className="pb-4 font-display text-2xl text-gold">:</span>
      <Box v={m} l="Min" />
      <span className="pb-4 font-display text-2xl text-gold">:</span>
      <Box v={s} l="Sec" />
    </div>
  );
};
